function Capsule({ children, className }) {
    return <div id="appCapsule" className={className}>{children}</div>
}

export default Capsule;